import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { DateHelper } from '../../helpers/date.helper';

@Injectable({ providedIn: 'root' })
export class ProcessesApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/processes`;
  }

  async setProcessIsQuarantined(processId: string, isQuarantined: boolean, endOfQuarantine?: Date): Promise<void> {
    return await this.patch(`${processId}/is-quarantined`, { isQuarantined, endOfQuarantine: endOfQuarantine ? DateHelper.formatApiDateTime(endOfQuarantine) : undefined });
  }

  async setProcessIsPinned(processId: string, isPinned: boolean): Promise<void> {
    return await this.patch(`${processId}/is-pinned`, { isPinned });
  }
}
